import { useIntl } from 'react-intl'
import ErrorPage from './ErrorPage'

/**
 * Not found page
 * @constructor
 */
const NotFound = () => {
	const { formatMessage } = useIntl()

	return (
		<ErrorPage
			code={formatMessage({ id: 'global.errorPages.notFound.code' })}
			explanation={formatMessage({ id: 'global.errorPages.notFound.explanation' })}
			message={formatMessage({ id: 'global.errorPages.notFound.message' })}
		/>
	)
}

export default NotFound
